import { Box, styled, Typography } from '@mui/material';

export const OverlayRow = styled(Box)`
    display: flex;
    background: rgba(0, 0, 0, 0.4);
    padding: ${({ theme }) => theme.spacing(1)};
    padding-top: ${({ theme }) => theme.spacing(0.5)};
    padding-bottom: ${({ theme }) => theme.spacing(0.5)};
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    gap: ${({ theme }) => theme.spacing(1)};
`;

export const OverlayLabel = styled(Typography)`
    font-size: 11px;
    line-height: 11px;
    display: flex;
    align-items: center;
    font-variant-numeric: tabular-nums;
    font-family: 'Roboto Mono';
`;
